import { SiteContentContext } from '../context/site-content.context';
import { SiteContext, SiteContextConfig } from '../models/site-context.model';
import { CollectionDisplay } from './collections/CollectionDisplay';

interface Props {
    context: SiteContext | undefined;
    config: SiteContextConfig;
    activeCollectionId: string;
    contentClassName?: string;
}

export const SiteDisplay = ({
    context,
    config,
    activeCollectionId,
    contentClassName,
}: Props): React.ReactElement<any, any> | null => {
    if (!context) {
        return null;
    }

    return (
        <SiteContentContext.Provider value={{ ...context, config }}>
            <CollectionDisplay
                collectionId={activeCollectionId}
                contentClassName={contentClassName}
            />
        </SiteContentContext.Provider>
    );
};
